<template>
    <div class="myMiner">
        <!--头部-->
        <Header title="我的矿机" :show-back="true"/>
        <div class="myMiner-recive" @click="reciveFun">
            一键领取
        </div>
        <div class="wrapper">
            <div class="pancel">
                <dl>
                    <dt class="effect">{{useful_good}}</dt>
                    <dd>有效矿机数</dd>
                </dl>
                <dl>
                    <dt class="uneffect">{{unuseful_good}}</dt>
                    <dd>无效矿机数</dd>
                </dl>
            </div>
            <van-list
                    class="myMiner-list"
                    v-model="loading"
                    @load="onLoad"
                    :offset="30"
                    :finished="isFinished">
                <div class="myMiner-item" v-for="(item,index) in list" :key="index">
                    <img src="../../assets/img/index/miner1.png" class="item-image"/>
                    <div class="right">
                        <dl class="desc">
                            <dt>矿机类型：</dt>
                            <dd>{{item.good_name}}</dd>
                        </dl>
                        <dl class="desc">
                            <dt>矿机已产币：</dt>
                            <dd class="currency">{{item.get_num}}</dd>
                        </dl>
                        <dl class="desc">
                            <dt>是否有效：</dt>
                            <dd>{{item.status===1? '有效':'无效'}}</dd>
                        </dl>
                        <dl class="desc">
                            <dt>购买日期：</dt>
                            <dd>{{item.add_time}}</dd>
                        </dl>
                    </div>
                </div>
            </van-list>
        </div>
        <van-dialog
                v-model="comfirmRevice"
                title="领取"
                :closeOnClickOverlay="true"
                confirm-button-text="一键领取"
                confirm-button-color="#1FC26D"
                v-on:confirm="onRecive">
            <p class="recive-text">矿机已产币：<span class="currency">{{cash_num}}</span></p>
        </van-dialog>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import {Toast} from 'vant';
    import {Dialog} from 'vant';

    export default {
        components: {
            Header
        },
        data() {
            return {
                list: [],
                useful_good: '',
                unuseful_good: '',
                cash_num: '',
                total: 0,
                page: 1,
                loading: false,
                isFinished: false,
                comfirmRevice: false
            }
        },
        created() {
            this.getData()
        },
        methods: {
            reciveFun() {
                if (this.useful_good) {
                    this.comfirmRevice = true
                } else {
                    Dialog.alert({
                        message: '暂无矿机无法领取'
                    })
                }
            },
            onRecive() {
                this.comfirmRevice = false;
                this.ajax.post('appapi/Miner/getMinerCoin', {}).then((res) => {
                    console.log(res.data.data);
                    if (res.data.code === 1) {
                        Toast('领取成功')
                    }
                })
            },
            getData(page = 1) {
                this.ajax.post('appapi/Miner/myGoods', {
                    status: 0,
                    page
                }).then((res) => {
                    console.log(res.data.data)
                    if (res.data.code === 1) {
                        let data = res.data.data
                        this.list = this.list.concat(data.good_list.data)
                        this.useful_good = data.useful_good
                        this.cash_num = data.cash_num
                        this.unuseful_good = data.unuseful_good
                        this.total = data.good_list.total
                        this.loading = false
                        this.page = parseInt(data.good_list.current_page, 10)
                        if (this.list.length >= this.total) {
                            this.isFinished = true
                        }
                    }
                })
            },
            onLoad() {
                if (!this.isFinished) {
                    this.getData(this.page + 1)
                }
            }
        }
    }
</script>

<style lang="scss">
    .myMiner {
        background: #fff;
        min-height: 100vh;
        position: relative;
        width: 100%;
        overflow: hidden;

        .wrapper {
            padding: 17px 30px;

            .pancel {
                @include flex();
                height: 140px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 12px 34px 0px rgba(48, 77, 120, 0.1);
                border-radius: 20px;
                padding: 35px 0;
                margin-bottom: 40px;

                dl {
                    flex: 1;
                    text-align: center;
                    font-size: 22px;
                    color: #AEBACB;
                }

                dt {
                    font-size: 34px;
                    margin-bottom: 10px;
                }

                .effect {
                    color: #0EC15E;
                }

                .uneffect {
                    color: #DF5334;
                }
            }
        }

        &-item {

            img {
                width: 223px;
                height: 167px;
            }

            @include flex();

            .right {
                font-size: 24px;
                margin-left: 30px;
                flex: 1;
                padding: 8px 0 20px;
                position: relative;

                :after {
                    border: 0.5px solid #EFF0F1;
                    content: '';
                    position: absolute;
                    box-sizing: border-box;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                }

                .desc {
                    @include flex();
                    margin-bottom: 10px;

                    dt {
                        width: 40%;
                        color: #AEBACB;
                    }

                    dd {
                        color: #4F5668;
                        font-weight: bold;

                        &.currency {
                            color: #DF5334;
                        }
                    }
                }

            }
        }

        &-recive {

            width: 188px;
            height: 52px;
            border-radius: 26px;
            padding-left: 28px;
            line-height: 52px;
            position: absolute;
            top: 27px;
            right: -30px;
            color: #fff;
            font-size: 28px;
            background: #0EC15E;
            // margin:0 12px 0 18px;

        }

        .recive-text {
            color: #747E89;
            font-size: 30px;
            padding: 35px 0 67px 42px;

            .currency {
                color: #DF5334;
                font-size: 40px;
            }
        }

    }
</style>
